import '../App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle';
import Body from '../body/Levels';
import Hero from '../hero/hero';
import BreadCrumb from '../utility/breadCrumb';

function Index() {
  return (
    <>
      <BreadCrumb 
        linkto="levels" 
        linkname="From Beginner to Advanced..." 
        linklevel="1" 
        linktoone="" 
        linknameone=""
        linktotwo="" 
        linknametwo="" 
      >
      </BreadCrumb>
      <Hero 
        paddingTop = "0px"
        id="5" 
        contentId="5"
        height="300" 
        gradient="true" 
        gradientDirection="to right" 
        gradientRgba="rgba(0,0,0,1) 76%, transparent" 
        backgroundSize="auto 100%" 
        backgroundRepeat="no-repeat" 
        backgroundColor="#000" 
        backgroundPosition="right"
        maxWidth="1400px"
        margin="auto"  >
      </Hero>
      <Body id="6"></Body>
    </>
  );
}

export default Index;
